import clsx from 'clsx';
import { ReactNode } from 'react';

import styles from './SectionBlock.module.scss';

type Props = {
  title: ReactNode;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
};

/**
 * Gray rounded card with a bold heading and a free-form content slot. Used for
 * the labelled sections on the eval detail pages (Description, Grading Prompt,
 * Produces Metrics, Prompt Parameters). Inherits the deprecated tint via the
 * `--source-section-bg` custom property set by the surrounding tab.
 */
export function SectionBlock( { title, children, className, 'data-testid': dataTestId }: Props ) {
  return (
    <section className={ clsx( styles.block, className ) } data-testid={ dataTestId }>
      <h3 className={ styles.heading }>{ title }</h3>
      { children }
    </section>
  );
}
